<template>
  <div>
    <v-container class="grey lighten-5">
      <v-row no-gutters class="pagination-table-header">
        <v-col
          col="12"
        >
          <v-overlay
            :absolute="true"
            :value="isComponentLoading"
          >
            <v-progress-circular indeterminate size="24"></v-progress-circular>
          </v-overlay>
          <v-card
            v-if="L.isEmpty(paginatedObject) || L.isEmpty(paginatedObject.data)"
            class="pa-3">
            <p class="text-center mt-2">
              <v-icon>mdi-account-search-outline</v-icon>
              <b>&nbsp;&nbsp;{{lang($store, 'sap/listings.not_found')}}&nbsp;&nbsp;</b>
              <v-icon>mdi-account-badge-outline</v-icon>
            </p>
          </v-card>
          <div v-else>
            <v-row>
              <v-col
                v-for="(item, key) in paginatedObject.data"
                :key="'col_' + key"
                cols="12" lg="3"
                md="4" sm="6"
                class="py-1"
              >
                <v-card
                  class="pa-1"
                  :style="{background: negativeBackground(item)}"
                >
                  <div>
                    <div style="display: none">{{item.uuid}}</div>
                    <div v-if="item.order && item.order.contact">
                      <contact-line
                        :contact="item.order.contact"/>
                      <v-divider/>
                      <cleaner-line
                        v-if="item.order.foreman"
                        :cleaner="item.order.foreman"
                        :not-found-text="lang($store, 'sap/listings.orders.foreman_not_set')"
                      />
                      <cleaners-line
                        :cleaners="item.order.cleaners"/>
                      <v-divider/>
                    </div>
                    <div class="d-flex flex-row">
                      <router-link :to="{ name: 'negatives.show', params: { negativeUuid: item.uuid }}">
                        <v-icon small>mdi-briefcase-edit-outline</v-icon>
                      </router-link>
                      <trash-button @click="onItemDelete(item)"/>
                      <comment-input
                              :value="item.minicomment"
                              :update-request="updateSimpleRequest(item, 'minicomment')"
                              @updated:text="item.minicomment = $event; $forceUpdate()"
                      />
                    </div>
                    <div class="d-flex flex-row">
                      <datetime-alert
                        :text="$t('negatives.negative_created_at')"
                        type="DATE_VIEW"
                        :icon="false"
                        v-if="item.created_at"
                        :datetime="moment(item.created_at)"
                      />
                    </div>
                    <div>
                      <comment-input
                              class="w-100"
                              :value="item.minicomment2"
                              :update-request="updateSimpleRequest(item, 'minicomment2')"
                              @updated:text="item.minicomment2 = $event; $forceUpdate()"
                      />
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
/* proxies */
import EstimationComplexProxy from '@/proxies/Estimations/EstimationComplexProxy';
/* constants */
/* utils */
/* mixins */
import isComponentLoading from '@/mixins/isComponentLoading';
/* components */
import DatetimeAlert from '@/components/minialerts/DatetimeAlert.vue';
import ContactLine from '@/components/minialerts/ContactLine.vue';
import TrashButton from '@/components/minialerts/TrashButton.vue';
import CommentInput from '@/components/minialerts/CommentInput.vue';
import CleanersLine from '@/components/minialerts/CleanersLine.vue';
import CleanerLine from '@/components/minialerts/CleanerLine.vue';
import negativeUpdateSimpleProp from '@/mixins/negatives/negativeUpdateSimpleProp';
import { OPEN } from '@/constants/negative_statuses';
import { LIGHT, HARD } from '@/constants/negative_levels';
import { roles as rolesColors } from '../../utils/listingColors';


export default {
  name: 'TablePaginatedNegatives',
  components: {
    DatetimeAlert,
    ContactLine,
    TrashButton,
    CleanersLine,
    CleanerLine,
    CommentInput,
  },
  mixins: [isComponentLoading, negativeUpdateSimpleProp],
  props: {
    paginatedObject: {
      type: Object,
      default: () => {
      },
    },
    noActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      moment,
      rolesColors,
      OPEN: OPEN,
      LIGHT: LIGHT,
      HARD: HARD,
      L: _,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
  },
  methods: {
    cardColor(item) {
      return 'white';
    },
    onItemEdit(item) {
      this.$emit('edit-item', item);
    },
    onItemDelete(item) {
      this.$emit('delete-item', item);
    },
    onItemCopy(item) {
      this.$emit('copy-item', item);
    },
    onPreview(item) {
      this.$emit('preview-item', item);
    },

    onAddressEdit(item, address) {
      this.$emit('edit-address', {
        item,
        address,
      });
    },
    onAddressDelete(item, address) {
      this.$emit('delete-address', {
        item,
        address,
      });
    },
    getUpdateSimpleRequestClient() {
      return new EstimationComplexProxy();
    },
    negativeBackground(item) {
      if (item.status !== this.OPEN) {
        return '#7bffac';
      }
      return item.level === this.LIGHT ? '#ff8a1b94' : '#fe555594';
    },
  },
};
</script>

<style lang="sass" scoped>
  .table-action
    &:hover
      fill: #0066ff
      transition: fill 0.5s
      cursor: pointer
</style>
